import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
// import HelloWorld from '@/views/HelloWorld'
import Home from '@/views/Home.vue'
// import HelloWorld from './views/HelloWorld.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(
    err => (console.log(err))
  )
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      hidden: true
    }, {
      path: '/home',
      name: 'Home',
      component: Home,
      hidden: true,
      meta: {
        roles: ['admin', 'user']
      }//,
      /*
            children: [
              {
                path: '/chat',
                name: '在线聊天',
                component: FriendChat,
                hidden: true
              }, {
                path: '/hrinfo',
                name: '个人中心',
                component: HrInfo,
                hidden: true
              }
            ]
      */
    }, {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js